import React, { useEffect } from 'react'
import { useFocusable } from '@noriginmedia/norigin-spatial-navigation'
import { noOp } from '../../../../shared/helpers'

import type { FocusableButtonProps } from './types'

const FocusableButtonTS = <T,>({
  children,
  onEnterPress = noOp,
  onArrowPress,
  onFocus = noOp,
  className = '',
  disabled = false,
  focusKey,
  stealFocus,
  extraProps,
}: FocusableButtonProps<T>) => {
  const { ref, focused, focusSelf } = useFocusable({
    onEnterPress,
    onArrowPress,
    onFocus,
    focusKey,
    extraProps,
  })

  useEffect(() => {
    if (stealFocus) {
      focusSelf()
    }
  }, [stealFocus, focusSelf])

  return (
    <button
      ref={ref}
      disabled={disabled}
      className={`focusable-button ${
        focused && !disabled ? 'focusable-button--focused' : ''
      } ${disabled ? 'focusable-button--disabled' : ''} ${className}`}
    >
      {children}
    </button>
  )
}

export default FocusableButtonTS
